import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import {DatePipe} from '@angular/common';
import {SelectItem, TreeNode} from 'primeng/primeng';
import {SearchToolbarModel} from './search-toolbar.model';
import {
  AreaModel, CardModeModel, ClusterModel, DateListModel,
  GroupModel, GroupTypeModel, StoreComboModel
} from '../../../../services/analytics/analytics.model';
import {TranslateService} from '@ngx-translate/core';
import {Category, CategoryTree} from '../../../../models/category.model';
import { StoreCampaignService } from '../../../../services/store/stores-campaign.service';
import { PromoTypeAnalyticsModel } from '../../../../models/promo-type-analytics.model';
import { CampaignService } from '../../../../services/campaign/campaign.service';

@Component({
  selector: 'kv-search-toolbar',
  templateUrl: 'search-toolbar.component.html',
  styleUrls: ['search-toolbar.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [CampaignService]
})
export class SearchToolbarComponent implements OnChanges, OnInit {

  @Input() card_modes: CardModeModel[];
  @Input() date_structure: DateListModel;
  @Input() clusters: ClusterModel[];
  @Input() group_types: GroupTypeModel[];
  @Input() stores: StoreComboModel[];
  @Input() groups: GroupModel[];
  @Input() areas: AreaModel[];
  @Input() product_categories: Category[];
  @Input() product_subsectors: CategoryTree[];
  @Input() analytics_promo: PromoTypeAnalyticsModel[];

  @Input() isToolbarOpen= true;
  @Input() toolbarFilterSummary = '';

  @Input() disableMutualExclusivity = false;

  @Input() dateBoxEnabled = true;
  @Input() customersBoxEnabled = true;
  @Input() storesBoxEnabled = true;
  @Input() productsBoxEnabled = false;
  @Input() promoBoxEnabled = false;

  @Input() cardModeFieldEnabled = true;
  @Input() clusterFieldEnabled = true;
  @Input() groupTypesFieldEnabled = true;
  @Input() areaFieldEnabled = true;
  @Input() dateFromFieldEnabled = true;
  @Input() groupFieldEnabled = true;
  @Input() storeFieldEnabled = true;

  @Input() storeSelectionMode = 'multi';

  @Input() selectedElapsedStart: Date  = null;
  @Input() selectedElapsedEnd: Date = null;

  @Input() couponCategoryFilter = false;

  @Output() onDateStructureSelectionChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCardModeChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onGroupTypeChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onProductCategoryChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onPromoTypeChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onGetCouponProducts: EventEmitter<any> = new EventEmitter<any>();
  @Output() onApply: EventEmitter<SearchToolbarModel> = new EventEmitter<SearchToolbarModel>();

  card_mode_items: SelectItem[];
  cluster_items: SelectItem[];
  group_type_items: SelectItem[];
  store_items: SelectItem[];
  groups_items: SelectItem[];
  elapsed_start_items: SelectItem[];
  elapsed_end_items: SelectItem[];
  area_items: SelectItem[];
  product_categories_items: SelectItem[];
  promo_type_items: SelectItem[];
  promotion_items: SelectItem[];
  selected_card_mode: any;
  selected_clusters: any;
  selected_group_type: any;
  selected_area: any;
  selected_stores: any;
  selected_groups: any;
  elapsed_start: any;
  elapsed_end: any;
  sectors_depth: number;
  selectedPromoType: any;
  selectedPromotion: any;

  all_key = 'ALL';
  all_description: string;

  showProductsDialog = false;
  selectedSectors: TreeNode[];
  selectedCategory: SelectItem;
  checkNodesLevel = true;
  selected_sectors_items: SelectItem[];

  constructor (
    private datePipe: DatePipe,
    private translate: TranslateService,
    private campaignStoreSrv: StoreCampaignService,
    private campaignService: CampaignService
  ) { }

  ngOnInit(): void {
    this.selected_card_mode = {};
    this.selected_groups = [];
    this.selected_clusters = [];
    this.selected_group_type = {};
    this.selected_stores = [];
    this.selected_area = {};
    this.selected_sectors_items = [];

    if (this.productsBoxEnabled) {
      if (!this.product_categories) {
        this.product_categories = this.campaignStoreSrv.categories;

        this.campaignStoreSrv.getCategories().subscribe(categories => {
          this.product_categories = categories;

          this.ngOnChanges({['product_categories']: {previousValue: [], currentValue: categories, firstChange: false, isFirstChange(): boolean { return false; }}});
        });
      }

      if (!this.product_subsectors) {
        this.product_subsectors = this.campaignStoreSrv.subsectors_tree;
      }
    }

    if (this.promoBoxEnabled) {
      if (!this.analytics_promo) {
        this.campaignStoreSrv.getAnalyticsPromoList().subscribe(res => {
          this.analytics_promo = res;

          this.ngOnChanges({['analytics_promo']: {previousValue: [], currentValue: res, firstChange: false, isFirstChange(): boolean { return false; }}});
        });
      }
    }

    this.translate.get(['common.all']).subscribe(res => {
      this.all_description = res['common.all']
    })
  }

  ngOnChanges(changes: SimpleChanges): void {

    console.log('changes search toolbar', changes);
    if (changes['date_structure'] && changes['date_structure'].currentValue != null) {
      this.elapsed_start_items = [];
      const dates: DateListModel = changes['date_structure'].currentValue;
      console.log('dates', dates);
      dates.forEach((ends, start) => {
        this.elapsed_start_items.push({
          value: start.getTime(),
          label: this.datePipe.transform(start, 'dd/MM/yyyy')
        })
      });

      if (this.elapsed_start_items.length > 0) {
        let pre_selected_date = this.elapsed_start_items[0].value;

        if (this.selectedElapsedStart != null) {
          pre_selected_date = this.elapsed_start_items.find(dt => dt.value === this.selectedElapsedStart.getTime()).value;
          if (pre_selected_date == null) {
            pre_selected_date = this.elapsed_start_items[0].value;
          }
          this.selectedElapsedStart = null;    // necessario in modo che la preselezione si verifichi solo al primo onchange
          this.selectedElapsedEnd = null;
          this.elapsed_end_items = [];
        }

        if (pre_selected_date != null) {
          this.elapsed_start = pre_selected_date;
        }
        this.onLocalElapsedStartChange({ value: this.elapsed_start})
      } else {
        this.selectedElapsedEnd = null;
        this.elapsed_end_items = [];
      }

    }

    if (changes['card_modes'] && changes['card_modes'].currentValue != null) {
      this.card_mode_items = [];
      changes['card_modes'].currentValue.forEach(c => {
        this.card_mode_items.push({
          label: c.description,
          value: c.code
        })
      });
      this.selected_card_mode = this.card_mode_items[0].value;
      this.onLocalCardModeChange({value: this.selected_card_mode})
    }

    if (changes['clusters'] && changes['clusters'].currentValue != null) {
      this.cluster_items = [];
      changes['clusters'].currentValue.forEach(c => {
        this.cluster_items.push({
          label: c.description,
          value: c.code
        })
      });
      this.selected_clusters = []
    }

    if (changes['group_types'] && changes['group_types'].currentValue != null) {
      this.group_type_items = [{
        label: this.all_description,
        value: this.all_key
      }];
      changes['group_types'].currentValue.forEach(g => {
        this.group_type_items.push({
          label: g.type,
          value: g.type
        })
      });
      this.selected_group_type = this.group_type_items[0].value;
      this.onLocalGroupTypeChange({value: this.selected_group_type})
    }

    if (changes['groups'] && changes['groups'].currentValue != null) {
      this.groups_items = [];
      changes['groups'].currentValue.forEach(a => {
        this.groups_items.push({
          label: a.description,
          value: a.code
        })
      });
      this.selected_groups = [];
      this.onLocalGroupChange({value: []})
    }

    if (changes['areas'] && changes['areas'].currentValue != null) {
      this.area_items = [{
        label: this.all_description,
        value: this.all_key
      }];
      changes['areas'].currentValue.forEach(a => {
        this.area_items.push({
          label: a.description,
          value: a.code
        })
      });
      this.selected_area = this.area_items[0].value;
      this.onLocalAreaChange({value: this.selected_area})
    }

    if (changes['stores'] && changes['stores'].currentValue != null) {
      this.store_items = [];
      changes['stores'].currentValue.forEach(a => {
        this.store_items.push({
          label: a.description,
          value: a.code
        })
      });
      this.selected_stores = [];
      this.onLocalStoreChange({value: []})
    }

    if (changes['product_categories'] && changes['product_categories'].currentValue != null) {
      this.product_categories_items = [{
        label: '',
        value: 'uncategorized'
      }];

      changes['product_categories'].currentValue.forEach(c => {
        this.product_categories_items.push({
          label: c.descrizione_subsettore,
          value: c.descrizione_subsettore
        });
      })
    }

    if (changes['analytics_promo'] && changes['analytics_promo'].currentValue != null) {
      this.promo_type_items = [{
        label: '',
        value: null
      }];

      for (const c of changes['analytics_promo'].currentValue) {
        this.promo_type_items.push({
          label: c.promo_type_descr,
          value: c.promo_type_code
        });
      }
    }

  }

  onOpenToolbar() {
    this.toolbarFilterSummary = ''
  }

  onCloseToolbar() {
    const filter = this.buildFilters();

    let filter_array = [];

    if (filter.elapsed_start) { filter_array.push(filter.elapsed_start.toLocaleString(this.translate.currentLang)); }
    if (filter.elapsed_end) { filter_array.push(filter.elapsed_end.toLocaleString(this.translate.currentLang)); }
    if (filter.clusters) { filter_array.push(filter.clusters); }
    if (filter.card_mode) { filter_array.push(filter.card_mode); }
    if (filter.group_type) { filter_array.push(filter.group_type); }
    if (filter.groups) { filter_array.push(filter.groups); }
    if (filter.area) { filter_array.push(filter.area); }
    if (filter.stores) { filter_array.push(filter.stores); }
    if (filter.sectors) { filter_array.push(filter.sectors); }
    if (filter.promotions) { filter_array.push(filter.promotions); }

    this.toolbarFilterSummary = filter_array.join(' | ');
  }

  onLocalElapsedStartChange(date_item) {
    this.elapsed_end_items = [];

    this.date_structure.forEach((ends, start) => {
      if (start.getTime() === date_item.value) {
        ends.forEach(end_date => {
          if (end_date.getTime() >= start.getTime()) {
            this.elapsed_end_items.push({
              value: end_date.getTime(),
              label: this.datePipe.transform(end_date, 'dd/MM/yyyy')
            })
          }
        });
        this.elapsed_end_items.sort((d1, d2) => d1.value - d2.value)
      }
    });

    let pre_selected_date = this.elapsed_end_items[0].value;
    if (this.selectedElapsedEnd != null) {
      pre_selected_date = this.elapsed_end_items.find(dt => dt.value === this.selectedElapsedEnd.getTime()).value;
      if (pre_selected_date == null) {
        pre_selected_date = this.elapsed_end_items[0].value;
      }
      this.selectedElapsedEnd = null // necessario in modo che la preselezione si verifichi solo al primo onchange
    }

    if (this.elapsed_end_items.length > 0) {
      this.elapsed_end = pre_selected_date;
    }

    this.onDateStructureSelectionChange.emit({source: 'start', value: date_item});

  }

  onLocalElapsedEndChange(date_item) {
    this.onDateStructureSelectionChange.emit({source: 'end', value: date_item});

  }

  onLocalCardModeChange(value) {
    this.onCardModeChange.emit(value);
  }

  onLocalGroupTypeChange(group) {
    if (this.group_types && this.group_types != null && this.group_types.length > 0) {

      this.selected_groups = [];
      const gt = this.group_types.find(gtf => gtf.type === group.value);
      this.groups_items = [];
      if (gt && gt != null) {
        gt.groups.forEach(g => {
          this.groups_items.push({
            label: g.description,
            value: g.code
          })
        })
      }
    }

    if (!this.disableMutualExclusivity) {
      this.selected_stores = []
    }

    this.onGroupTypeChange.emit(group)
  }

  onLocalGroupChange(groups) {
    if (!this.disableMutualExclusivity) {
      this.selected_stores = []
    }
  }

  onLocalAreaChange(area) {
    if (!this.disableMutualExclusivity) {
      this.selected_stores = []
    }
  }

  onLocalStoreChange(stores) {
    if (!this.disableMutualExclusivity) {
      this.selected_area = this.all_key;
      this.selected_groups = [];
      this.selected_group_type = this.all_key
    }

    if (this.storeSelectionMode === 'single' && stores.value.length > 0) {
      this.selected_stores = [ stores.itemValue ]
    }
  }

  onChangeCategory(category) {
    this.selectedCategory = category;

    if (this.productsBoxEnabled) {
      this.campaignStoreSrv.getSubsectorsTree(category.value).subscribe(subsectors => {
        this.product_subsectors = subsectors;
      });
    }

    this.onProductCategoryChange.emit(category.value);
  }

  onPromoChange(promo) {
    this.promotion_items = [];

    this.selectedPromoType = promo;
    this.selectedPromotion = null;

    if (this.promoBoxEnabled) {

      if (promo.value) {
        const type = this.analytics_promo.find(p => p.promo_type_code === promo.value);

        type.promotions.forEach(promotionModel => {
          this.promotion_items.push({value: promotionModel.code, label: promotionModel.description});
        });

        if (this.promotion_items.length > 0) {
          this.selectedPromotion = this.promotion_items[0].value;
        }
      }
    }

    this.onPromoTypeChange.emit(promo.value);
  }

  buildFilters() {
    return {
      elapsed_start: this.dateFromFieldEnabled ? new Date(this.elapsed_start) : null,
      elapsed_end: new Date(this.elapsed_end),
      clusters: this.customersBoxEnabled && this.clusterFieldEnabled && this.selected_clusters.length > 0 ? this.selected_clusters : null,
      card_mode: this.customersBoxEnabled && this.cardModeFieldEnabled ? this.selected_card_mode : null,
      group_type: this.storesBoxEnabled && this.groupTypesFieldEnabled && this.selected_group_type !== this.all_key ? this.selected_group_type : null,
      group_type_code: this.storesBoxEnabled && this.groupTypesFieldEnabled && this.selected_group_type !== this.all_key ? this.group_types.find(gt => gt.type === this.selected_group_type).code : null,
      groups: this.storesBoxEnabled && this.groupFieldEnabled && this.selected_groups.length > 0 ? this.selected_groups : null,
      area: this.storesBoxEnabled && this.areaFieldEnabled && this.selected_area !== this.all_key ? this.selected_area : null,
      stores: this.storesBoxEnabled && this.storeFieldEnabled && this.selected_stores.length > 0 ? this.selected_stores : null,
      sectors: this.productsBoxEnabled && this.selected_sectors_items.length > 0 ? { depth: this.sectors_depth, sectors: this.selected_sectors_items.map(i => i.value) } : null,
      promotions: this.promoBoxEnabled && this.selectedPromotion ? this.selectedPromotion : null
    };
  }

  evaluateDepth(sector): number {
    let depth = 0;
    let item = Object.assign({}, sector);
    while (item.parent) {
      depth = depth + 1;
      item = item.parent;
    }
    return depth;
  }

  checkSelectedNode(event) {
    let depth = -1;
    this.checkNodesLevel = true;

    for (const s of this.selectedSectors) {
      const newDepth = this.evaluateDepth(s);
      if (depth !== -1 && depth !== newDepth) {
        this.checkNodesLevel = false;
        break;
      }

      depth = newDepth;
      this.sectors_depth = newDepth;
    }

    console.log('subsector', event.node, this.evaluateDepth(event.node))
  }

  displayProducts() {
    this.showProductsDialog = true;
  }

  resetProducts() {
    this.selected_sectors_items = []
  }

  selectProducts() {
    this.selected_sectors_items = [];
    this.selectedSectors.forEach(s => {
      this.selected_sectors_items.push({
        label: s.data.description,
        value: s.data.id
      })
    });
    if (this.couponCategoryFilter) {
      let selectedCategoriesLevel: string;
      let selectedCategoriesCodes: number[] = [];
      switch (this.sectors_depth) {
        case 0:
          selectedCategoriesLevel = 'subsettore';
          break;
        case 1:
          selectedCategoriesLevel = 'reparto';
          break;
        case 2:
          selectedCategoriesLevel = 'categoria';
          break;
        case 3:
          selectedCategoriesLevel = 'subcategoria';
          break;
        case 4:
          selectedCategoriesLevel = 'famiglia';
          break;
        case 5:
          selectedCategoriesLevel = 'subfamiglia';
          break;
        case 6:
          selectedCategoriesLevel = 'articolo';
          break;
      }
      this.selected_sectors_items.forEach(item => selectedCategoriesCodes.push(parseInt(item.value)));
      this.onGetCouponProducts.emit([selectedCategoriesLevel, selectedCategoriesCodes]);
    }
    this.showProductsDialog = false;
  }

  apply() {
    this.onApply.emit(this.buildFilters())
  }

  nicelyIdTreeView(ugly) {
    return ugly.split('#')[0];
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/UIKit/components/searchToolBar/search-toolbar.component.ts